import type { FC } from 'react';
import { useEffect } from 'react';
import { twcls } from '@utils/twcls';

const SCRIPT_SRC = 'https://res.smartwidgets.ru/app.js';

interface SmartWidgetReviewsProps {
  /** SmartWidgets app id (`data-app`) for the reviews widget to render. */
  appId: string;
  className?: string;
}

const SmartWidgetReviews: FC<SmartWidgetReviewsProps> = ({
  appId,
  className
}) => {
  useEffect(() => {
    // Re-inject the script on every mount so it re-scans the DOM and picks up
    // this mount's `.sw-app` node. Keeping a stale script across SPA navigations
    // leaves the widget uninitialised (the script only scans once on load).
    document.querySelector(`script[src="${SCRIPT_SRC}"]`)?.remove();

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [appId]);

  return (
    <div className={twcls('w-full mb-20', className)}>
      <div className='sw-app' data-app={appId} />
    </div>
  );
};

export default SmartWidgetReviews;
